import React, { useState, useMemo, useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { useUserContext } from 'providers/UserProvider';

import Table from 'components/common/Table';
import PicklistShipmentDetailPanel from './PicklistShipmentDetailPanel';

import { picklistApi } from 'api';

import { getPicklistDetailShipmentColumns } from 'constants/picklist';

const PicklistShipments = ({ picklistId }) => {
  const [showDetail, setShowDetail] = useState(false);
  const [selectedShipmentInfo, setSelectedShipmentInfo] = useState(null);

  const { selectedTenant, selectedWarehouse } = useUserContext();
  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const handleViewDetail = useCallback(
    async shipmentId => {
      try {
        const detail = await picklistApi.getShipmentDetailOfPicklist(
          picklistId,
          shipmentId,
        );
        setSelectedShipmentInfo(detail);
        setShowDetail(true);
      } catch (err) {
        console.error('Failed to fetch shipment detail:', err);
      }
    },
    [picklistId],
  );

  const handleCloseDetail = () => {
    setShowDetail(false);
    setSelectedShipmentInfo(null);
  };

  const extendedColumns = useMemo(() => {
    const detailColumn = {
      accessorKey: 'actions',
      header: '',
      meta: {
        headerProps: { className: 'text-center' },
        cellProps: { className: 'text-center' },
      },
      cell: ({ row: { original } }) => {
        return (
          <Button
            size="sm"
            variant="falcon-default"
            onClick={() => handleViewDetail(original.id)}
          >
            View
          </Button>
        );
      },
    };

    return [
      ...getPicklistDetailShipmentColumns(tenant, warehouse),
      detailColumn,
    ];
  }, [tenant, warehouse, handleViewDetail]);

  return (
    <>
      <Table
        title={`Picklists #${picklistId} Shipments`}
        apiService={picklistApi}
        columns={extendedColumns}
        fetchConfig={{
          method: 'getShipmentsOfPicklist',
          enablePagination: true,
        }}
        resourceId={picklistId}
        initialPageSize={25}
        initialFilter={{ tab: 'shipments' }}
      />

      <PicklistShipmentDetailPanel
        show={showDetail}
        onHide={handleCloseDetail}
        shipmentDetail={selectedShipmentInfo}
      />
    </>
  );
};

export default PicklistShipments;
